import { render, staticRenderFns } from "./new_feature_modal.vue?vue&type=template&id=2373313d&scoped=true&"
import script from "./new_feature_modal.vue?vue&type=script&lang=js&"
export * from "./new_feature_modal.vue?vue&type=script&lang=js&"
import style0 from "./new_feature_modal.vue?vue&type=style&index=0&id=2373313d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2373313d",
  null
  
)

export default component.exports